/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

import Config from '@config/Config';

import './ExternalLoginPage.css';
import tmplExternalLoginPage from './ExternalLoginPage.hbs';

const ExternalLoginPage = View.extend({
  template: tmplExternalLoginPage,

  className: 'external-login-page',

  ui: {
    btnLogin: '.btn-login',
    helpUnPw: '.help-unpw',
    helpCAC: '.help-cac',
    needHelpBtn: '#btnHelp',
    fileLinkViewContainer: '.file-link-container'
  },

  regions: {
    fileLinkViewContainer: '@ui.fileLinkViewContainer'
  },

  events: {
    'click #linkRegister': 'register',
    'click @ui.needHelpBtn': 'displayHelpText',
    'click @ui.btnLogin': 'onClickLogin'
  },

  templateContext() {
    return {
      bannerText: Config.getBannerText()
    };
  },

  onClickLogin() {
    window.location.href = Config.getExternalOtdsLogInUrl(window.location.href);
  },

  register(e) {
    e.preventDefault();
    Radio.channel('navigate').request('show:ext:cac-register-page');
  }
});

export default ExternalLoginPage;
